import {http} from '@/http'

export default {
  list(params)     { return http.get('/banks', { params }) },
  listActive()     { return http.get('/banks/active') },
  get(id)          { return http.get(`/banks/${id}`) },
  save(data)       { return http.post('/banks', data) },
  update(id, data) { return http.put(`/banks/${id}`, data) },
  changeStatus(id, status) {
    return http.put(`/banks/${id}/status`, null, { params: { status } })
  },
}
